<template>
    <div class="generalizeRecord">
        <div class="searchBox">
            <el-date-picker class="dealTime" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" 
                type="datetimerange" v-model="time"></el-date-picker>
            <el-input class="keyword" v-model.trim="params.keyword" placeholder="输入推广员昵称/手机号"></el-input>
            <el-button @click.native="search">搜索</el-button>
            <el-button type="primary" @click.native="exportExtensionRecode">导出Excel</el-button>
        </div>
        <el-table ref="multipleTable" :data="tableData" style="width: 100%">
            <el-table-column prop="ordertime" label="交易时间"></el-table-column>
            <el-table-column prop="orderno" width="165px" label="订单号" class-name="center"></el-table-column>
            <el-table-column prop="clientnickname" label="购买人" class-name="center"></el-table-column>
            <el-table-column prop="promoternickname" label="推广员昵称" class-name="center"></el-table-column>
            <el-table-column prop="promotermobileno" label="推广员手机号" class-name="center"></el-table-column>
            <el-table-column prop="kmcname" label="商品名称" class-name="center"></el-table-column>
            <el-table-column prop="ordermoney" label="交易金额" class-name="center"></el-table-column>
            <el-table-column prop="brokeragerate" label="佣金比例" class-name="center">
                <template slot-scope="scope">
                    <div class="brokeragerate">
                        {{scope.row.brokeragerate}}%
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="statustext" label="状态" class-name="center"></el-table-column>
        </el-table>
        <Page :total="total" ref="page"></Page>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import Page from '@/base/page/page'
import {dateFormat} from 'common/js/tools'
import {extensionRecode, exportExtensionRecode} from '@/api/extensionAgent'
export default {
    name: 'generalizeRecord',
    data() {
        return {
            total: 0,
            params: {
                beginTime: '',
                endTime: '',
                keyword: ''
            },
            time: '',
            tableData: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            }
        }
    },
    mounted() {
        this.getRecordList()
    },
    methods: {
        getRecordList() {
            this.setLoading(true)
            extensionRecode({
                data: Object.assign({}, this.params, this.$refs.page.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        exportExtensionRecode() {
            exportExtensionRecode({
                data: Object.assign({}, this.params),
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '推广记录' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        search() {
            this.getRecordList()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'time': {
            handler(newV, oldV) {
                if (!newV) {
                    this.params.beginTime = ''
                    this.params.endTime = ''
                } else {
                    this.params.beginTime = newV[0]
                    this.params.endTime = newV[1]
                }
            }
        }
    },
    components: {
        Page
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
    .generalizeRecord{
        .searchBox{
            margin-top: 15px;
            .dealTime{
                width: 224px;
                margin-right: 30px;
                .el-input__icon{
                    line-height: 24px;
                }
                .el-range-separator{
                    line-height: 24px;
                }
            }
            .keyword{
                width: 330px;
                margin-right: 30px;
            }
            .el-button{
                margin-right: 30px;
            }
        }
        .el-table{
            margin-top: 40px;
            .center{
                .cell{
                    text-align: center;
                }
            }
        }
    }
</style>